import React, { Component } from 'react';
import { EDLegendBox } from './EDLegendBox';

export class EDLegendTable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        ///Tabella della legenda
        return (
            <tr>
                    {this.props.arrLegend.map(legend => {
                        return <td>
                            <EDLegendBox legendCode={legend}></EDLegendBox>
                        </td>
                    })}
            </tr>
        );
    } 
}

